export enum ServiceStatus {
  PASS = 'pass',
  WARN = 'warn',
  FAIL = 'fail',
  OFFLINE = 'offline',
}

export type ServiceName =
  | 'user'
  | 'file'
  | 'vehicle'
  | 'property'
  | 'job'
  | 'revision'
  | 'permit'
  | 'notification'
  | 'redirect'
  | 'topsPPIAdapter'
  | 'payment'
  | 'findMyCar'
  | 'qrCode'
  | 'permitClient';

export type HealthCheck = {
  service: ServiceName;
  status: ServiceStatus;
};
